import React from 'react';
import {
  useTransportationLinesCount,
  useTransportationsCount,
} from '../../../api/transportations';

type TransportationLinesCountProps = {
  linked?: boolean;
  attention?: boolean;
  isGBS?: boolean;
  types?: Array<'standalone' | 'combined'>;
  status?: Array<
    'created' | 'sent' | 'received' | 'packaged' | 'packagedCombined'
  >;
  name?: string;
  supplierId?: number;
  methodsIds?: string[];
  localMethodsIds?: string[];
};

export function TransportationLinesCount(props: TransportationLinesCountProps) {
  const { data: count, isLoading } = useTransportationLinesCount({
    linked: props.linked,
    attention: props.attention,
    isGBS: props.isGBS,
    types: props.types,
    status: props.status,
    name: props.name,
    supplierId: props.supplierId,
    methodsIds: props.methodsIds,
    localMethodsIds: props.localMethodsIds,
  });
  if (isLoading) {
    return (
      <>
        <i className="bi bi-three-dots color-gray-400" />
      </>
    );
  }

  return <>{count}</>;
}

export function TransportationsCount(props: TransportationLinesCountProps) {
  const { data: count, isLoading } = useTransportationsCount({
    linked: props.linked,
    attention: props.attention,
    isGBS: props.isGBS,
    types: props.types,
    status: props.status,
    name: props.name,
    supplierId: props.supplierId,
    methodsIds: props.methodsIds,
    localMethodsIds: props.localMethodsIds,
  });
  if (isLoading) {
    return (
      <>
        <i className="bi bi-three-dots color-gray-400" />
      </>
    );
  }

  return <>{count}</>;
}
